import { render, staticRenderFns } from "./SithMesInventoryStockReturnList.vue?vue&type=template&id=2b7e9db7&"
import script from "./SithMesInventoryStockReturnList.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryStockReturnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports